/**
 * Athletic Power Metrics API utilities
 * This file provides functions for interacting with the athletic power metrics endpoints
 */
import config from './config';

// API base URL from config
const API_BASE_URL = config.API_BASE_URL;

/**
 * Get all athletic power metrics
 * @returns {Promise<Array>} Array of all athletic power metrics
 */
export const getAllAthleticPowerMetrics = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/athletic-power-metrics`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch athletic power metrics: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error getting all athletic power metrics:', error);
    throw error;
  }
};

/**
 * Get athletic power metrics for a specific Roster
 * @param {string} playerId - The ID of the Roster
 * @returns {Promise<Object>} The Roster's athletic power metrics
 */
export const getAthleticPowerMetricsByPlayerId = async (playerId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/rosters/${playerId}/athletic-power-metrics`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch athletic power metrics for Roster: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error getting athletic power metrics by Roster ID:', error);
    throw error;
  }
};

/**
 * Save athletic power metrics
 * @param {Object} metrics - The metrics data to save
 * @returns {Promise<Object>} The saved metrics data
 */
export const saveAthleticPowerMetrics = async (metrics) => {
  try {
    const response = await fetch(`${API_BASE_URL}/athletic-power-metrics`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(metrics),
    });
    
    if (!response.ok) {
      throw new Error(`Failed to save athletic power metrics: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error saving athletic power metrics:', error);
    throw error;
  }
};

export default {
  getAllAthleticPowerMetrics,
  getAthleticPowerMetricsByPlayerId,
  saveAthleticPowerMetrics
};